import { USER_ROLES } from "../lib/supabase";

// Role Sets for O(1) lookups
export const ALL_ROLES = new Set(Object.values(USER_ROLES));

export const NON_ADMIN_ROLES = new Set([
  USER_ROLES.GENERAL,
  USER_ROLES.BRAND,
  USER_ROLES.CAUSE,
  USER_ROLES.INFLUENCER,
]);

export const VERIFIED_ROLES = new Set([
  USER_ROLES.BRAND,
  USER_ROLES.CAUSE,
  USER_ROLES.INFLUENCER,
  USER_ROLES.ADMIN,
]);

export const CREATOR_ROLES = new Set([
  USER_ROLES.BRAND,
  USER_ROLES.CAUSE,
  USER_ROLES.INFLUENCER,
]);

// Main navigation items
export const MAIN_NAV_CONFIG = [
  {
    id: "visit-main",
    title: "Visit Main Site",
    href: "/",
    external: true,
    visibleTo: ALL_ROLES,
  },
  {
    id: "dashboard",
    title: "Dashboard",
    href: "/dashboard",
    visibleTo: ALL_ROLES,
  },
  {
    id: "campaigns",
    title: "Create a Campaign",
    href: "/dashboard/launch-campaign/step1?new=true",
    visibleTo: CREATOR_ROLES,
  },
  {
    id: "my-campaigns",
    title: "My Campaigns",
    href: "/dashboard/my-campaigns",
    visibleTo: CREATOR_ROLES,
  },
  {
    id: "brands",
    title: "Brands",
    href: "/dashboard/brands",
    visibleTo: new Set([USER_ROLES.GENERAL, USER_ROLES.INFLUENCER]),
  },
  {
    id: "causes",
    title: "Causes",
    href: "/dashboard/cause",
    visibleTo: new Set([USER_ROLES.GENERAL, USER_ROLES.INFLUENCER]),
  },
  {
    id: "collections",
    title: "Collections",
    href: "/dashboard/collections",
    visibleTo: NON_ADMIN_ROLES,
  },
  {
    id: "create-dot",
    title: "List Impact Art",
    href: "/dashboard/create-dot",
    visibleTo: NON_ADMIN_ROLES,
  },
  {
    id: "my-dots",
    title: "My Impact Art",
    href: "/dashboard/dots",
    visibleTo: NON_ADMIN_ROLES,
  },
  // Hidden after the campaign form simplification (Phase 1): these pages read
  // Campaign.impact.milestones[], which new campaigns no longer populate, so they
  // render empty.
  // {
  //   id: "milestones",
  //   title: "Milestones",
  //   href: "/dashboard/milestones",
  //   visibleTo: VERIFIED_ROLES,
  // },
  // "Updates" moved from a standalone dashboard subsection to a per-campaign
  // action (My Campaigns > campaign actions menu > Add Update).
  {
    id: "approval-status",
    title: "Approval Status",
    href: "/dashboard/approval-status",
    visibleTo: NON_ADMIN_ROLES,
  },
  {
    id: "cause-campaign-approvals",
    title: "Campaign Approvals",
    href: "/dashboard/cause-campaign-approvals",
    visibleTo: new Set([USER_ROLES.CAUSE]),
  },
  {
    id: "admin-requests",
    title: "User Requests",
    href: "/dashboard/admin-requests",
    visibleTo: new Set([USER_ROLES.ADMIN]),
  },
  {
    id: "admin-insights",
    title: "Platform Insights",
    href: "/dashboard/admin-insights",
    visibleTo: new Set([USER_ROLES.ADMIN]),
  },
  {
    id: "campaign-status",
    title: "Campaign Status",
    href: "/dashboard/campaign-status",
    visibleTo: new Set([USER_ROLES.ADMIN]),
  },
  {
    id: "admin-causes",
    title: "Causes",
    href: "/dashboard/admin-causes",
    visibleTo: new Set([USER_ROLES.ADMIN]),
  },
  {
    id: "admin-brands",
    title: "Brands",
    href: "/dashboard/admin-brands",
    visibleTo: new Set([USER_ROLES.ADMIN]),
  },
  {
    id: "admin-support",
    title: "Support",
    href: "/dashboard/admin-support",
    visibleTo: new Set([USER_ROLES.ADMIN]),
  },
];

// Secondary navigation items
export const SECONDARY_NAV_CONFIG = [
  {
    id: "notifications",
    title: "Notifications",
    href: "/dashboard/notifications",
    visibleTo: ALL_ROLES,
  },
  {
    id: "identity-verification",
    title: "Identity Verification",
    href: "/dashboard/identity-verification",
    visibleTo: NON_ADMIN_ROLES,
  },
  {
    id: "profile",
    title: "Profile",
    href: "/dashboard/profile",
    visibleTo: ALL_ROLES,
  },
  {
    id: "settings",
    title: "Settings",
    href: "/dashboard/settings",
    visibleTo: ALL_ROLES,
  },
  {
    id: "feedback",
    title: "Send Feedback",
    href: "/dashboard/feedback",
    visibleTo: ALL_ROLES,
  },
];

// Page access for route guards
export const PAGE_ACCESS = {
  generalRestricted: new Set([
    "/dashboard/launch-campaign",
    "/dashboard/my-campaigns",
    "/dashboard/milestones",
  ]),
  verifiedRestricted: new Set(["/dashboard/brands", "/dashboard/cause"]),
  adminOnly: new Set([
    "/dashboard/admin-requests",
    "/dashboard/admin-insights",
    "/dashboard/campaign-status",
    "/dashboard/admin-causes",
    "/dashboard/admin-brands",
    "/dashboard/admin-support",
  ]),
  causeOnly: new Set(["/dashboard/cause-campaign-approvals"]),
};
